import React from 'react'
import './loading.css'
export default function Loading() {
  return (
    <div className="g-loading-gif">
        <div>
        <img src="/Dual Ball-1s-200px (1).gif" alt="one" />
        </div>
      </div>
  )
}
